import getValueReduxUtil from 'modules/redux/utils/get-value'
import {
  DAY_KEY,
  isLoggedWorkoutUtil
} from '@gymaholic/packages'
import {
  isBeforeDateUtil,
  isSameDayDateUtil
} from 'packages/src'
import { isRestDayUtil } from 'modules/day/utils/isRest/index.js'

/**
 * @param day
 * @param hasCompletedADayWithWorkoutsBefore
 * @returns {false|this is T[]|boolean}
 */
export const isCompletedDayUtil = ({
  day,
  hasCompletedADayWithWorkoutsBefore
}) => {
  const workouts = getValueReduxUtil(day, DAY_KEY.WORKOUTS) || []
  const isRest = isRestDayUtil(day)
  const plannedAtStr = getValueReduxUtil(day, DAY_KEY.PLANNED_AT)

  const plannedAt = plannedAtStr ? new Date(plannedAtStr) : null
  const today = new Date()
  if (
    isRest &&
    hasCompletedADayWithWorkoutsBefore &&
    plannedAtStr &&
    (
      isBeforeDateUtil(plannedAt, today) &&
      !isSameDayDateUtil(plannedAt, today)
    )
  ) {
    return true
  }

  return (
    !isRest &&
    workouts.every(workout => {
      return !!isLoggedWorkoutUtil(workout)
    })
  )
}
